export const USER_LOADING = 'auth/USER_LOADING';
export const INIT_ADMIN_LOGIN = 'saga/auth/INIT_ADMIN_LOGIN';

export const TOKEN = 'auth/TOKEN';
export const DECODE_TOKEN = 'auth/DECODE_TOKEN';
export const TOKEN_REFRESH = 'auth/TOKEN_REFRESH';